import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { DEFAULT_LANGUAGE } from 'constants/language';
import { trimWhitespace } from 'utils/text/trimWhitespace';
export default function useAddressForm(address) {
  const addressForm = useForm({
    mode: 'onChange',
    defaultValues: {
      addressLine1: address?.addressLine1 ? trimWhitespace(address?.addressLine1) : '',
      addressLine2: address?.addressLine2 || '',
      postalCode: address?.postalCode || '',
      postalDistrict: address?.postalDistrict || '',
      careOfName: address?.careOfName || '',
      countryCode: address?.countryCode || DEFAULT_LANGUAGE,
      makeStandard: address?.makeStandard || false
    }
  });
  useEffect(() => {
    if (address) addressForm.reset({
      ...address
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);
  return addressForm;
}